// @flow

import Unit from '@/lib/unit';
import MichaelisMentenEquation from '@/lib/michaelis_menten_equation';

// いちいち設定するのが面倒なので、デフォルト値を用意する
// s: 0 ~  => 傾き
// h: 0 ~ => 最大成長速度
// x: 0.00 ~ 1.00 => 日光量
// - 陰樹用のデフォルト定数
const dTreeConstatns = {
  s: 0.11,
  h: 8,
  k: 1,
  requiredSoilNutrition: 50,
};
// - 陽樹用のデフォルト定数
const sTreeConstatns = {
  s: 0.08,
  h: 1,
  k: 1,
  requiredSoilNutrition: 50,
};

export default class {
  static process(unit: Unit) {
    if (!unit.template.categories.includes('tree')) return false;
    let defaults = {};
    if (unit.template.type.match(/^d_tree/)) {
      defaults = dTreeConstatns;
    } else if (unit.template.type.match(/^s_tree/)) {
      defaults = sTreeConstatns;
    }
    const constants = unit.template.constants || {};
    const requiredSoilNutrition =
      constants.requiredSoilNutrition || defaults.requiredSoilNutrition || 0;
    const s = constants.s || defaults.s || 0;
    const h = constants.h || defaults.h || 0;

    // 要求する土壌栄養度を満たしている割合（要求量を満たしていたら成長率を 1.0 にする）
    const cellSoilNutrition: number = unit.getParameter(
      'cell',
      'soilNutrition'
    );
    let soilNutritionSatisfyRate = cellSoilNutrition / requiredSoilNutrition;
    if (isNaN(soilNutritionSatisfyRate)) soilNutritionSatisfyRate = 1.0;
    if (soilNutritionSatisfyRate > 1.0) soilNutritionSatisfyRate = 1.0;

    // ミカエリス-メンテン式での成長量計算
    const x = unit.treeSunlight / 100;
    // 要求する土壌栄養度を満たしていない場合、成長量を減らす
    unit.treeHeight +=
      MichaelisMentenEquation.calculate(s, h, x) * soilNutritionSatisfyRate;
    unit.treeHeight = unit._restrictValue(
      unit.treeHeight,
      unit.template.maxHeight
    );
  }
}



// WEBPACK FOOTER //
// ./src/lib/unit_event/grow_height_event.js